"use strict";Object.defineProperty(exports, "__esModule", {value: true});// Mirrors the server's rule (apps/backend/pkg/bloom/sms_stop_line.go): the
// text is trimmed, counted in characters, and while it's on it can't be
// empty and must name an opt-out keyword as a whole word, in any case.

 const normalizeStopLine = (text) => text.trim(); exports.normalizeStopLine = normalizeStopLine

 const stopLineLength = (text) => [...exports.normalizeStopLine.call(void 0, text)].length; exports.stopLineLength = stopLineLength

const STOP_LINE_KEYWORD = /\b(stop|unsubscribe|cancel|end|quit)\b/i

 const STOP_LINE_KEYWORD_HINT = 'Include STOP so patients know how to opt out.'; exports.STOP_LINE_KEYWORD_HINT = STOP_LINE_KEYWORD_HINT

/** Why the line can't be saved as it is, or null when it can. */
 const stopLineSaveBlocker = (enabled, text, maxLength) => {
  if (exports.stopLineLength.call(void 0, text) > maxLength) return `Keep it to ${maxLength} characters or fewer.`
  if (enabled && !exports.normalizeStopLine.call(void 0, text)) return 'Add a line, or turn it off.'
  if (enabled && !STOP_LINE_KEYWORD.test(exports.normalizeStopLine.call(void 0, text))) return exports.STOP_LINE_KEYWORD_HINT
  return null
}; exports.stopLineSaveBlocker = stopLineSaveBlocker

/** The server's reason for refusing a save, as a sentence. */
 const stopLineSaveError = (e) => {
  const reason = e && typeof e === 'object' && 'Error' in e && typeof e.Error === 'string'
    ? e.Error.trim()
    : ''
  if (!reason) return "Couldn't save the opt-out line. Try again."
  return reason.charAt(0).toUpperCase() + reason.slice(1) + (/[.!?]$/.test(reason) ? '' : '.')
}; exports.stopLineSaveError = stopLineSaveError
